import React, { PropsWithChildren, useContext } from 'react';
import omit from 'lodash/omit';
import { useWidgetContext, WidgetContextType } from 'widgets/WidgetContext';

export interface TileContextType {
    /*
     * Widget key of the containing tiles widget
     */
    tilesWidgetKey: string;
    /*
     * Whether symbol configuration should be allowed at the capsule level
     */
    disableSymbolConfig: boolean;
}

const defaultTileContext = {} as TileContextType;

export const TileContext =
    React.createContext<TileContextType>(defaultTileContext);

export type TileContextProviderProps = PropsWithChildren<TileContextType>;

export function TileContextProvider(props: TileContextProviderProps) {
    const value = omit(props, 'children');
    return (
        <TileContext.Provider value={value}>
            {props.children}
        </TileContext.Provider>
    );
}

export const useTileContext: () => WidgetContextType & TileContextType = () => {
    const widgetContext = useWidgetContext();
    const tileContext = useContext(TileContext);
    return { ...widgetContext, ...tileContext };
};
